import { useCallback, useMemo } from 'react'
import { useUserSelectLabel } from 'components/CIMSSelect/common/UserSelect/hooks/useUserSelectLabel'
import { useUserSelectTooltip } from 'components/CIMSSelect/common/UserSelect/hooks/useUserSelectTooltip'
import { useUserSelectContext } from 'components/CIMSSelect/common/UserSelect/UserSelectContext'
import { PermissionUser } from '../types'

export function usePermissionUsers() {
  const { loading, users } = useUserSelectContext()
  const label = useUserSelectLabel()
  const tooltip = useUserSelectTooltip()
  const usersById = useMemo(
    () =>
      users.reduce<Map<string, PermissionUser>>(
        (map, user) => map.set(user.id, user),
        new Map()
      ),
    [users]
  )

  const userLabel = useCallback(
    (id: string) => {
      const user = usersById.get(id)
      return user ? label(user) : `Unknown user (${id})`
    },
    [label, usersById]
  )

  const userTooltip = useCallback(
    (id: string) => {
      const user = usersById.get(id)
      return user ? tooltip(user) ?? undefined : 'This user could not be found.'
    },
    [tooltip, usersById]
  )

  return {
    loading: !!loading,
    userLabel,
    usersById,
    userTooltip,
  }
}
